exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-55e37feb] {\n  width: 1.4rem;\n}\n.margin[data-v-55e37feb] {\n  margin-left: 40px;\n}\n.container[data-v-55e37feb] {\n  background-color: var(--theme-light-gray);\n  min-height: 14em;\n}\n.containerError[data-v-55e37feb] {\n  min-height: 7em;\n  padding: 1.5em 2em 1.5em 2em\n}\n@media screen and (max-width: 500px) {\n.retail[data-v-55e37feb] {\n    margin-left: 20px;\n}\n} \n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55e37feb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/forms/CodeMessage.vue
// module id = 685
// module chunks = 0